import { OBSIDIAN } from 'HubStyleTokens/colors';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIFlex from 'UIComponents/layout/UIFlex';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FeatureText = styled(FormattedHTMLMessage).withConfig({
  displayName: "ChecklistItem__FeatureText",
  componentId: "sc-1qsc2rs-0"
})(["font-size:", "px;"], ({
  fontSize
}) => fontSize);
const StyledFlex = styled(UIFlex).withConfig({
  displayName: "ChecklistItem__StyledFlex",
  componentId: "sc-1qsc2rs-1"
})(["cursor:", ";"], ({
  tooltipMessage
}) => tooltipMessage && 'help');
const ChecklistItem = ({
  tooltipMessage,
  message,
  secondaryMessage,
  className,
  iconName = 'success',
  iconColor = OBSIDIAN,
  fontSize = 14
}) => {
  return /*#__PURE__*/_jsx(UITooltip, {
    placement: "top",
    title: tooltipMessage && /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: tooltipMessage
    }),
    children: /*#__PURE__*/_jsxs(StyledFlex, {
      className: className,
      tooltipMessage: tooltipMessage,
      children: [/*#__PURE__*/_jsx(UIIcon, {
        className: "m-right-3",
        color: iconColor,
        name: iconName
      }), /*#__PURE__*/_jsx(FeatureText, {
        message: message,
        fontSize: fontSize
      }), secondaryMessage && /*#__PURE__*/_jsx("span", {
        className: "m-left-1",
        children: /*#__PURE__*/_jsx(FeatureText, {
          message: secondaryMessage,
          fontSize: fontSize
        })
      })]
    })
  });
};
export default ChecklistItem;